import { useSearchLimitRestriction } from '@aibees/elephant/hooks/use-search-limit-restriction';
import { ROUTES } from '@aibees/elephant/router';
import { DialogTitle } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { useMatchPath } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchLimitAlertDialogFreeUserMessage } from './components/search-limit-alert-dialog-free-user-message';
import { SearchLimitAlertDialogPaidUserMessage } from './components/search-limit-alert-dialog-paid-user-message';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchLimitAlertDialogProps as Props } from './types';

export const SearchLimitAlertDialog = memo(({ className }: Props) => {
  const navigate = useNavigate();
  const isPricingPage = useMatchPath(ROUTES.priceAndPlan);
  const { limitReached, isFreeUser, setLimitReached } =
    useSearchLimitRestriction();
  const state = useBoolean(!isPricingPage ? limitReached : false);

  const handleClose = () => {
    state.onFalse();
    setLimitReached(false);
  };

  const handleGoToUpgrade = () => {
    navigate(ROUTES.priceAndPlan);
  };

  return (
    <Styled.Wrapper
      className={classnames('SearchLimitAlertDialog', className)}
      sx={SX.root}
      open={state.value}
      fullWidth
      maxWidth="xs"
      onClose={handleClose}
    >
      <DialogTitle
        title="Search Limit Reached"
        icon="problem"
        onClose={handleClose}
      />

      <DialogContent sx={SX.content}>
        {isFreeUser ? (
          <SearchLimitAlertDialogFreeUserMessage />
        ) : (
          <SearchLimitAlertDialogPaidUserMessage />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="default"
          onClick={handleClose}
          size="small"
        >
          Close
        </Button>
        {isFreeUser && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoToUpgrade}
            size="small"
          >
            Upgrade
          </Button>
        )}
      </DialogActions>
    </Styled.Wrapper>
  );
});

SearchLimitAlertDialog.displayName = 'SearchLimitAlertDialog';
